module.exports = __webpack_public_path__ + "static/media/house8.ba2de9e0.png";